import React, { Component } from 'react'
import styled from 'styled-components'
import Helmet from 'react-helmet'

import ConnectedDotCollectionView from '../View/ConnectedDotCollectionView'

import { StandardScreen } from './Screen'
import Image from '../View/Image'

const AInner = styled.div`
display: flex;
flex-direction: column;
align-items: center;

#logo {
  margin: 60px 0;
  margin-bottom: 30px;
}

#message {
  white-space: pre-line;
  line-height: 1.7;
}

#dots-container {
  margin: 60px 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}
`

class A extends Component {
  render() {
    const message = `
    MandalArt のご愛用、ありがとうございます。
    
    
    このページは、MandalArt や LifeArt のユーザをサポートするために創りました。
    
    必ずしも初心者のためばかりではありません。
    
    人間、時には初心にかえって、心をリフレッシュする必要もあります。初心を忘れるなということです。
    
    という意味で 
    
    ベテランの、あなたにも、読んで欲しいのです。
    
    
    今後とも、お役に立てそうな情報を発信していくつもりです。` // Whitespaces will be omitted upfront when written directly
    
    return (
      <StandardScreen>
      <Helmet>
      <title>Welcome Seminar</title>
      </Helmet>
      <AInner>
      <h1 id="logo"><Image name="welcome-seminar-logo" alt="Welcome Seminar ロゴ"/></h1>
      <div id="message">{message}</div>
      <div id="dots-container">
      {this._renderElements()}
      </div>
      </AInner>
      </StandardScreen>
    )
  }
  
  _renderElements() {
    const { connectedDotCollections } = this.props
    const elements = (connectedDotCollections !== undefined) ? Elements.fromConnectedDotCollections(connectedDotCollections) : []
    return elements.map((element, i) => {
      switch (element.type) {
        case Element.TYPE.CONNECTED_DOT_COLLECTION:
        const cdc = element.connectedDotCollection
        return <ConnectedDotCollectionView connectedDotCollection={cdc} key={cdc.id} />
        case Element.TYPE.SEPARATOR:
        return <Separator key={1000 + i} />
        default:
        return null
      }
    })
  }
}

const Separator = styled.div`
width: 100%;
height: 0;
border-top: 1px solid black;
display: border-box;
margin: 2em 0;
`

class Elements {
  static fromConnectedDotCollections = (connectedDotCollections) => {
    var elements = []
    connectedDotCollections.forEach((cdc, i) => {
      elements.push(new ConnectedDotCollectionElement(cdc))
      const last = (i + 1 === connectedDotCollections.length)
      if (!last) {
        elements.push(new SeparatorElement())
      }
    })
    return elements
  }
}

class Element {
  static TYPE = {
    CONNECTED_DOT_COLLECTION: "CONNECTED_DOT_COLLECTION",
    SEPARATOR:                "SEPARATOR"
  }

  constructor() {
    this.type = undefined
  }
}

class ConnectedDotCollectionElement extends Element {
  constructor(connectedDotCollection) {
    super()
    this.type = Element.TYPE.CONNECTED_DOT_COLLECTION
    this.connectedDotCollection = connectedDotCollection
  }
}

class SeparatorElement extends Element {
  constructor() {
    super()
    this.type = Element.TYPE.SEPARATOR
  }
}

export default A


// WEBPACK FOOTER //
// ./src/App/Page/A.js